var processInclude = require("base/util");

/**
* Processes the sticky CTA component when the document is ready
*/
$(document).ready(function () {
    processInclude(require("designercss/components/stickyCta"));
    processInclude(require("./components/modal"));
});
